export enum EMBEDDED_CONFLUENCE_MODE {
	EDIT_MODE = 'edit',
	VIEW_MODE = 'view',
}
